import React from 'react';

import Product from '../Product';
import SelectMemberStamp from '../SelectMemberStamp';

const GalleryItem = ({
  name,
  description,
  image,
  customizeCampaign,
}) => (
  <div className="select-slide">
    <SelectMemberStamp />
    <Product
      image={image}
      name={name}
      description={description}
      customizeCampaign={customizeCampaign}
    />
  </div>
);

export default GalleryItem;
